import React, { useEffect, useState } from 'react';  //changes
import { useDispatch, useSelector } from 'react-redux';
import {get_UserWallet_Transaction,get_UserData} from '../../../store/actions/CommanAction';
import DataTable from 'react-data-table-component';
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import Select from "react-select";
import { customStyles } from '../Utility/Utility';


const UserWalletTransaction = () => {
    const dispatch = useDispatch();
    const UserWalletTransaction = useSelector((state) => state.feedBackReducer.UserWalletTransaction);
    const userData = useSelector((state) => state.feedBackReducer.UserData);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [orderStatus, setOrderStatus] = useState(null);
    const [loading, setloading] = useState(false);
    const [selectedAstro, setSelectedAstro] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [userName, setUserName] = useState("");
     const [timeoutId, setTimeoutId] = useState(null);


    useEffect(() => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;

        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;

        setStartTime(defaultStartTime);
        setEndTime(defaultEndTime);

        dispatch(get_UserWallet_Transaction(formattedToday, formattedToday, selectedAstro && selectedAstro.value ? selectedAstro.value : "",setloading));
    }, [dispatch]);

    useEffect(()=>
    {

      const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const formattedToday = `${yyyy}-${mm}-${dd}`;

        const defaultStartTime = `${formattedToday}`;
        const defaultEndTime = `${formattedToday}`;


       dispatch(get_UserWallet_Transaction(defaultStartTime, defaultEndTime,"",setloading)) 
    },[])




    useEffect(() => {

        const formatDate = (dateTime) => {
    if (!dateTime) return null;
    const date = new Date(dateTime);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const formattedStartDate = formatDate(startTime);
  const formattedEndDate = formatDate(endTime);

  const data = {
    FromDate: formattedStartDate,
    Todate: formattedEndDate,
    orderStatus: orderStatus,
  };


    
            if (!userName ) {
                dispatch(
    get_UserWallet_Transaction(
      data.FromDate,
      data.Todate,
      userName && userName.trim() !== "" ? userName.trim() : null, 
      setloading
    )
  );
                return;
            }
    
    
            if (userName.length < 3) return;
    
            if (timeoutId) clearTimeout(timeoutId);
    
            const newTimeoutId = setTimeout(() => {
                setloading(true);
               dispatch(
    get_UserWallet_Transaction(
      data.FromDate,
      data.Todate,
      userName && userName.trim() !== "" ? userName.trim() : null,
      setloading
    )
  );
                setloading(false);
            }, 500);
    
            setTimeoutId(newTimeoutId);
    
            return () => clearTimeout(newTimeoutId);
        }, [ userName]);





const handleSearch = (isActive) => {
  const formatDate = (dateTime) => {
    if (!dateTime) return null;
    const date = new Date(dateTime);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const formattedStartDate = formatDate(startTime);
  const formattedEndDate = formatDate(endTime);

  const data = {
    FromDate: formattedStartDate,
    Todate: formattedEndDate,
    orderStatus: orderStatus,
  };

  dispatch(
    get_UserWallet_Transaction(
      data.FromDate,
      data.Todate,
      userName && userName.trim() !== "" ? userName.trim() : "", 
      setloading
    )
  );
};


    useEffect(()=>{
        dispatch(get_UserData(setloading,isActive))
    },[])

    useEffect(() => {
        if (userData && Array.isArray(userData)) {
            const filtered = userData.map(({ NickName, UserID }) => ({
                label: NickName,
                value: UserID,
            }));
            setFilteredData(filtered);
        }
    }, [userData]);



    const columns = [

        {
            name: 'User Name',
            selector: (row) => row.UserName,
            sortable: true,width: '150px'
        },
       
        {
            name: 'Amount', selector: (row) => row.Amt, sortable: true,width: '150px',
        },
        {
            name: 'GST Amount', selector: (row) => row.GSTAmt, sortable: true,width: '150px'
        },
        {
            name: 'Date', selector: (row) => row.TransactionDateTime, sortable: true,width: '250px'
        },

        {
            name: 'Description', selector: (row) => row.Description, sortable: true,
        },

    ];
    return (
        <div>

            <div className="form-group">
                <h2 style={{ color: '#f7931e', fontWeight: 700 }}>User Wallet Transactions</h2>
                <div className="row mt-3">
                    <div className="col-3">
                        <label className="form-label">Start Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <label className="form-label">End Time</label>
                        <input
                            type="date"
                            className="form-control"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>
                    

<div className="col-3">
  <label className="form-label">Search by User Name</label>
  <input
    type="text"
    className="form-control"
    value={userName}
    onChange={(e) => setUserName(e.target.value)}
    placeholder="Enter user name"
  />
</div>


                </div>



                <button style={{width:"70px"}} className="btn btn-primary mt-3"   onClick={() => handleSearch(isActive)}>
                    Search
                </button>

            </div>


            <div className="col-12 mt-2">
                {loading ? (
                    <Loader />
                ) : (
                    <DataTable
                        dense
                        data={UserWalletTransaction || []}
                        columns={columns}
                        selectableRowsHighlight
                        pagination
                        persistTableHead={true}
                        noDataComponent={"There are no data to display"}
                           customStyles={customStyles}
                    />)}
            </div>
        </div>
    );
};
export default UserWalletTransaction;



